export const ANALYTICS_EVENT =
  process.env['NEXT_PUBLIC_ANALYTICS_EVENT'] || 'syl-ph-event'
